export const appointments = state => {
  return state.appointments
}
